module.exports = __webpack_public_path__ + "static/media/logo_gpbank.c6423d9f.svg";